import { featureEnabled } from "../helpers/getEnvVar";

export const FEATURE_CAMPAIGNS = featureEnabled('REACT_APP_FEATURE_CAMPAIGNS');
export const FEATURE_APPOINTMENTS = featureEnabled('REACT_APP_FEATURE_APPOINTMENTS');

export const FEATURE_ARCHIVE = featureEnabled('REACT_APP_FEATURE_ARCHIVE');

export const FEATURE_PASSKEY = featureEnabled('REACT_APP_FEATURE_PASSKEY');

export const FEATURE_PRODUCT_CERTIFICATE_WITH_AUTH = featureEnabled('REACT_APP_FEATURE_PRODUCT_CERTIFICATE_WITH_AUTH', true);
